import { Modal } from '#molecules';
import { useState } from 'react';

interface ExerciseMediaProps {
  images:
    | {
        id: string;
        resizedLink: string;
      }[]
    | null;
  videos:
    | {
        id: string;
        resizedLink: string;
      }[]
    | null;
}

export const ExerciseMedia = ({ images, videos }: ExerciseMediaProps) => {
  // 업로드한 파일 상세 모달 표시 여부
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  // 업로드한 상세 파일
  const [detailFileInfo, setDetailFileInfo] = useState<{
    resizedLink: string;
    isVideo: boolean;
  }>({
    resizedLink: '',
    isVideo: false
  });

  if (images?.length === 0 && videos?.length === 0) return null;

  return (
    <div className="px-20 py-32">
      <div className="overflow-x-auto flex-1 pt-8 pr-8 flex gap-12">
        {videos &&
          videos.length > 0 &&
          videos.map((fileInfo, index) => {
            const { id, resizedLink } = fileInfo;

            const onClick = () => {
              setDetailFileInfo({
                resizedLink,
                isVideo: true
              });

              setIsDetailModalOpen(true);
            };

            return (
              <div className="relative" key={id} onClick={onClick}>
                <div className="w-120 h-120 rounded-lg overflow-hidden border-1 border-solid border-[#373245]">
                  <video
                    playsInline={true}
                    preload="metadata"
                    controls
                    className="w-full h-full object-contain"
                  >
                    <source src={resizedLink} type="video/mp4" />
                  </video>
                </div>
              </div>
            );
          })}

        {images &&
          images.length > 0 &&
          images.map((fileInfo, index) => {
            const { id, resizedLink } = fileInfo;

            const onClick = () => {
              setDetailFileInfo({
                resizedLink,
                isVideo: false
              });

              setIsDetailModalOpen(true);
            };

            return (
              <div className="relative" key={id} onClick={onClick}>
                <div className="w-120 h-120 rounded-lg overflow-hidden border-1 border-solid border-[#373245]">
                  <img
                    className="w-full h-full object-contain"
                    src={resizedLink}
                    alt="업로드한 이미지"
                  />
                </div>
              </div>
            );
          })}
      </div>

      {isDetailModalOpen && !detailFileInfo.isVideo && (
        <Modal onClose={() => setIsDetailModalOpen(false)} transparent>
          {/* 추후 동영상도 렌더링해야할 경우 사용 */}
          {/* {detailFileInfo.isVideo ? (
            <VideoRenderer
              className="modal-video"
              controls={true}
              url={detailFileInfo.url}
            />
          ) : (
            <img className="modal-img" src={detailFileInfo.url} />
          )} */}
          <img className="modal-img" src={detailFileInfo.resizedLink} />
        </Modal>
      )}
    </div>
  );
};
